export default "__VITE_ASSET__T64UJJTO__"